import { SET_IS_MOBILE, CART_ACTIONS } from "./actionTypes";

export const setIsMobile = (isMobile) => ({
  type: SET_IS_MOBILE,
  payload: isMobile,
});

export const addToCart = (item, quantity) => ({
  type: CART_ACTIONS.ADD_TO_CART,
  payload: { ...item, quantity },
});

export const removeFromCart = (itemId) => ({
  type: CART_ACTIONS.REMOVE_FROM_CART,
  payload: itemId,
});

export const updateCartItem = (itemId, quantity) => ({
  type: CART_ACTIONS.UPDATE_CART_ITEM,
  payload: { itemId, quantity },
});

export const clearCart = () => ({
  type: CART_ACTIONS.CLEAR_CART,
});
